import { useState, type Ref } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { PASSWORD_MAX } from '../../core/rules/password';
import { inputCls, labelCls } from '../../ui/styles';
type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  /** `new-password` laat de wachtwoordmanager een sterk wachtwoord voorstellen. */
  autoComplete: 'new-password' | 'current-password';
  error?: string;
  hint?: string;
  inputRef?: Ref<HTMLInputElement>;
};

/**
 * Wachtwoordveld met tonen/verbergen, zoals op het inlogscherm. De hint en de fout staan onder
 * het veld en worden via `aria-describedby` mee voorgelezen.
 */
export function PasswordInput({
  id,
  label,
  value,
  onChange,
  autoComplete,
  error,
  hint,
  inputRef
}: Props) {
  const [show, setShow] = useState(false);
  const hintId = `${id}-hint`;
  const errorId = `${id}-error`;
  const describedBy = [hint ? hintId : '', error ? errorId : ''].filter(Boolean).join(' ') || undefined;
  return <div data-id="element-6395" data-mp="1m0jlnytxg899">
      <label htmlFor={id} className={labelCls} data-id="element-6396" data-mp="1m09uw9125x2i">
        {label}
      </label>
      <div className="relative" data-id="element-6397" data-mp="1ly6ssqmmsdhf">
        <input ref={inputRef} id={id} type={show ? 'text' : 'password'} autoComplete={autoComplete} maxLength={PASSWORD_MAX} value={value} onChange={e => onChange(e.target.value)} aria-invalid={error ? true : undefined} aria-describedby={describedBy} className={`${inputCls} pr-12`} data-id="element-6398" data-mp="1h1ygdkztiydy" />
        <button type="button" onClick={() => setShow(v => !v)} aria-label="Wachtwoord tonen" aria-pressed={show} aria-controls={id} className="absolute inset-y-0 right-0 flex w-12 items-center justify-center text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-6399" data-mp="y342ee86i1yu">
          {show ? <EyeOffIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6400" data-mp="2njlpc5ui6oa5" /> : <EyeIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6401" data-mp="2ihmkerj47jb3" />}
        </button>
      </div>
      {hint && <p id={hintId} className="mt-1.5 text-[13px] text-muted" data-id="element-6402" data-mp="1g7463tqxc3nm">
          {hint}
        </p>}
      {error && <p id={errorId} className="mt-1.5 text-[13px] text-clay" data-id="element-6403" data-mp="1p5ohe9u5nb1t">
          {error}
        </p>}
    </div>;
}